import { mutatorAction } from 'satcheljs';
import { getAnchorStore } from '../store/anchorStore';
import getTabIdFromWindow from '../utils/getTabIdFromWindow';
import getAnchorMapKey from '../utils/getAnchorMapKey';
import type { DrawerPaneAnchorSurface } from '../store/schema/DrawerPaneAnchorState';

/**
 * Registers (or clears) the mount node that drawer panes and the AppPaneUnderlay
 * should portal into for the given window, together with the product surface that
 * owns it (so consumers select width/styling by surface rather than inferring it
 * from whether an anchor merely exists). Pass `null` as the anchor to clear.
 */
const drawerPaneAnchorChangedMutator: (
    anchor: HTMLElement | null,
    surface: DrawerPaneAnchorSurface,
    targetWindow: Window,
    drawerPaneId: string
) => void = mutatorAction(
    'drawerPaneAnchorChanged',
    (
        anchor: HTMLElement | null,
        surface: DrawerPaneAnchorSurface,
        targetWindow: Window,
        drawerPaneId: string
    ): void => {
        const tabId = getTabIdFromWindow(targetWindow);
        const anchorKey = getAnchorMapKey(tabId, drawerPaneId);
        const { anchorMap } = getAnchorStore();
        if (anchor) {
            anchorMap.set(anchorKey, {
                element: anchor,
                surface,
            });
        } else {
            anchorMap.delete(anchorKey);
        }
    }
);

export default drawerPaneAnchorChangedMutator;
